import { render } from "./ShoppingCarCard.vue?vue&type=template&id=a660169c&scoped=true"
import script from "./ShoppingCarCard.vue?vue&type=script&lang=js"
export * from "./ShoppingCarCard.vue?vue&type=script&lang=js"

import "./ShoppingCarCard.vue?vue&type=style&index=0&id=a660169c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a660169c"]])

export default __exports__